import { ConcreteEncodable } from "./ConcreteEncodable";

import { PauseOrderDataImplEncoder } from "../../encoder/PauseOrderDataImplEncoder";

import * as CubiqTS from "../../index";
import { PauseOrderData } from "../PauseOrderData";

export class PauseOrderDataImpl extends ConcreteEncodable implements PauseOrderData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.PauseOrderDataImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public pauseState: CubiqTS.PauseState;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=4*/
  public isError: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PauseOrderDataImplEncoder.Instance;
    this.setEncodableType(PauseOrderDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PauseOrderDataImpl[" +
      "orderId=" +
      this.orderId +
      "pauseState=" +
      this.pauseState +
      "errors=" +
      this.errors +
      "isError=" +
      this.isError +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
